/*
 *
 * EconomicConditionsSelectorModal
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 24-Sep-2025
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as CostsActions from '../../routes/Costs/modules/CostsActions'
import EconomicConditionsSelectorModal from './EconomicConditionsSelectorModal'
import { doShowPopup, doHidePopup } from 'Store/actions/popup'
import { nullSafe } from 'Utility/globalMethods'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(CostsActions, dispatch),
  ...bindActionCreators({ doShowPopup, doHidePopup }, dispatch)
})

const mapStateToProps = (state) => ({
  shops: nullSafe(() => state.Costs.economicConditions.shopList, []),
  offerList: nullSafe(() => state.Costs.economicConditions.offerList, []),
  isMonoOffer: nullSafe(() => state.Costs.economicConditions.isMonoOffer, false),
  isSubmitting: nullSafe(() => state.loading.localLoading.get_contract, false),
  prefillValues: nullSafe(() => state.popup.popupInfo.prefillValues, {}),
  isOffersLoading: nullSafe(() => state.loading.localLoading.get_economic_conditions_offers, false)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(EconomicConditionsSelectorModal)
